import { defineComponent as r, createBlock as a, openBlock as n, normalizeProps as p, guardReactiveProps as l, withCtx as m, renderSlot as s, createElementVNode as i } from "vue";
import d from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ r({
  name: "Mail",
  __name: "mail",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (o, e) => (n(), a(d, p(l(t.props)), {
      default: m(() => [s(o.$slots, "default"), e[0] || (e[0] = i("path", {
        role: "presentation",
        d: "M21 5a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h18zm-1 3.536l-7.483 4.32a1 1 0 01-1.017.01L4 8.536V17h16V8.536zM18.658 7H5.34L12 10.845 18.658 7z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
